import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export default function IconEject({
    width = '20',
    height = '20',
    className,
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={classnames(css.main, className)}
            {...rest}
        >
            <g fill="none" fillRule="evenodd">
                <polygon fill="none" points="0 0 20 0 20 20 0 20" />
                <path
                    className={css.colored}
                    fillRule="nonzero"
                    d="M15.3625 12.4C15.7375 12.4 15.9925 12.13375 15.9925 11.80375 15.9925 11.68 15.95125 11.575 15.8875 11.46625L10.72375 4.32625C10.55125 4.1275 10.2925 4 10 4 9.71125 4 9.4525 4.1275 9.28 4.32625L4.105 11.48125C4.04125 11.57875 4.0075 11.6875 4.0075 11.8075 4.0075 12.13375 4.2625 12.4 4.6375 12.4L15.3625 12.4zM15.53875 13.6L4.465 13.6C4.21 13.6 4 13.8025 4 14.0575L4 15.5425C4 15.79375 4.20625 16 4.465 16L15.53875 16C15.79375 16 16 15.79375 16 15.5425L16 14.0575C16 13.8025 15.79375 13.6 15.53875 13.6z"
                />
            </g>
        </svg>
    );
}
